var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('AmeliproFooter',{attrs:{"version":_vm.version,"no-a11y":"","no-about":"","no-configuration":"","legal-notice-to":"/legal-notice","no-link-a11y":"","no-site-map":"","cgu-to":"/cgu"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }